import React from "react";

import { useIntl } from "react-intl";

import { isEmptyString } from "@mapmycustomers/shared/util/stringUtils";
import { Alert } from "@mapmycustomers/ui";

import WebsiteTextField, { WebsiteTextFieldProps } from "@app/component/input/WebsiteTextField";

import styles from "./CompanyWebsiteField.module.scss";

type CompanyWebsiteFieldProps = Omit<WebsiteTextFieldProps, "placeholder">;

const CompanyWebsiteField = (props: CompanyWebsiteFieldProps) => {
  const intl = useIntl();
  const isValueEmpty = isEmptyString(props.value);
  return (
    <>
      <WebsiteTextField
        {...props}
        placeholder={intl.formatMessage({
          id: "formFields.companyWebsite.placeholder",
          defaultMessage: "Website",
          description: "Company website placeholder",
        })}
      />
      {isValueEmpty && (
        <Alert
          className={styles.alert}
          message={intl.formatMessage({
            id: "formFields.companyWebsite.syncAllEmailsAlert",
            defaultMessage: "Add a website to sync all emails for a domain.",
            description: "Company website sync all emails for a domain alert",
          })}
          showIcon
        />
      )}
    </>
  );
};

export default CompanyWebsiteField;
